import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import moment from "moment";
import Chart from "chart.js";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import barchart from '../../custom_lib/AiCharts/craBarChart.vue';
import VisitPredictionDashboardModal from "../CraManagement/VisitPredictionDashboardModal.vue";
import CreateSchedulePopup from "../RAC_Insight/CreateSchedulePopup.vue";
import CraModal from "../CraManagement/CraScheduleModal.vue";
import CraAddEditModal from "../CraManagement/CraAddEditModal.vue";
import customModal from "../customModal/customModal.vue";
// let testarray= [];
const RISK_ORDER = [
  "SAE Rate",
  "Timeliness of data entry (SAEs)",
  "Major Protocol Deviation Rate",
  "Query aging (critical DP)",
  "Missing visits",
  "Enrollment rate",
  "Subject discontinuation rate",
  "Site Issue Outlier"
];

export default {
  name: "",
  components: { VPagination, VueCal,barchart,VisitPredictionDashboardModal,CreateSchedulePopup,CraModal, CraAddEditModal, customModal},
  emits: ["closeModal", "saved", "refreshCycleList"],
  async mounted() {
  try {
    // Initialize headers
    this.loading= true;  
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultdashboard = store.getters.getdefaultdashboard;
    this.sndcharts = null;
    this.studyId= store.getters.getStudyIs;
    
    // Get initial data
    this.roleprivileges = await store.getters.getRolesprivilegeData;
    this.valnow = await store.getters.getStudyIs;
    
    // Load all data in parallel for better performance
    await this.combineSiteApis();
    await this.getWeightedriskindexscore();
    await this.getTrendNewAnalyze();
    await Promise.all([
      this.renderDummyDoughnutChart(),
      this.loadSiteRiskMetrics(),
      this.getCraScheduleList(),
     // this.loadCraSchedule(),
      this.getgraphdata(),
      this.loadHighRiskScoreChart() ]);
    
    console.log("All data loaded successfully");
    console.log("Graph data:", this.data);

  } catch (error) {
    console.error("Error in mounted hook:", error);
  } finally {
    /* IMPORTANT LINE */
    this.loading = false;
  }

  // Add event listener for study ID changes
  window.addEventListener("studyIdChanged", async (event) => {
    try {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.defaultdashboard = store.getters.getdefaultdashboard;
      this.roleprivileges = await store.getters.getRolesprivilegeData;
      this.valnow = await store.getters.getStudyIs;
       await this.combineSiteApis();
      // Reload all data when study changes
      await Promise.all([
        this.loadSiteRiskMetrics(),
        this.getCraScheduleList(),
        this.loadCraSchedule(),
        this.countofloadSiteRiskMetrics(),
        this.countofoverdueRiskMetrics(),
        this.getgraphdata() ,
        this.loadHighRiskScoreChart(),
      ]);
      
    } catch (error) {
      console.error("Error in studyIdChanged event:", error);
    }
  });
  },
  // async mounted() {
 
  //   this.headerValues = {
  //     headers: {
  //       Authorization: "Bearer " + this.idToken,
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   this.defaultdate = localStorage.getItem("dateformat");
  //   window.addEventListener("studyIdChanged", async (event) => {
  //     this.defaultdashboard = store.getters.getdefaultdashboard;
  //     console.log("StudyIDChanged into" + event.detail.storage);
  //     // window.location.reload();
  //     // await this.loadstudy();
  //     this.roleprivileges = await store.getters.getRolesprivilegeData;
  //     this.valnow = await store.getters.getStudyIs;
  //     await this.loadSiteRiskMetrics();
  //     this.loadCraSchedule();

  //     this.getCraScheduleList();
  //     await this.countofloadSiteRiskMetrics();
  //     await this.getgraphdata();
      
  //   });
  //   this.defaultdashboard = store.getters.getdefaultdashboard;
  //   this.sndcharts = null;
  //   // await this.loadstudy();
  //   this.roleprivileges = await store.getters.getRolesprivilegeData;
  //   this.valnow = await store.getters.getStudyIs;
  //   await this.loadSiteRiskMetrics();
  //   this.getCraScheduleList();
  //   this.loadCraSchedule();
  //   await this.countofloadSiteRiskMetrics();
  // },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      studyId: null,
      showCreateCycleModal: false,
      headerValues: {},
      craScheduleMap: {},
      loading: false,
      selectedSiteCode: null,
      selectedcolumnobj: { 'CRA Visit Type': true, 'Monitoring Mode': true, 'Planned Date': true, 'Triggered By': true, 'Status': true },
      //loadCraSchedule: false,
      siteList: [],
      Allsites: [],
      trendNewAnalyze:[],
      kpiList:[],
      showKpiPerformance:false,
      expandedKpiSites: new Set(),
      createschedulemodel: false,
      craScheduleId: null,
      siteId: null,
      siteCodeforpopup: null,
      selectedSiteDetails: {
      kpis: [],
      },
      sites: [],
      studyversion: 1, // or fetch dynamically
      showCycleTableLoading: false,
      currentPage: 1,
      currentPageSite: 1,
      sitePerPage: 7,
      showCreateCraModal: false,
      showCraModel: false,
      data: [],
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      SortProperty: "",
      SortOrder: 1,
      craScheduleList: [],
      legendButtonText: "Show KPI Legend",
      showLegend: false,
      loadingCraSchedule: false,
      selectedSite: null,
      craEvents: [],
      highriskcount: "",
      overduevisitscount: "",
        firstchart: {
        charttype: ""
      },
      firstbarchart: {
        dataseries: [],
        chartOptions: {}
      },
      highRiskChart: null,
      };
  },
 computed: {
  keyRisks() {
    if (!this.selectedSite || !Array.isArray(this.selectedSite.risks)) {
      return [];
    }
    return this.selectedSite.risks;
  },

  paginatedSites() {
    const start = (this.currentPageSite - 1) * this.sitePerPage;
    const end = start + this.sitePerPage;
    return this.siteList.slice(start, end);
  },

  siteTotalPage() {
    return Math.ceil(this.siteList.length / this.sitePerPage);
  },
   prioritySummary() {

    const total = this.trendNewAnalyze.length || 1;

    const summary = {
      Immediate: 0,
      High: 0,
      Medium: 0,
      Low: 0,
      Normal: 0
    };

    this.trendNewAnalyze.forEach(site => {
      const level = site.attentionLevel || "Normal";

      if (summary[level] !== undefined) {
        summary[level]++;
      }
    });

    return {
      Immediate: {
        count: summary.Immediate,
        percent: ((summary.Immediate / total) * 100).toFixed(0)
      },
      High: {
        count: summary.High,
        percent: ((summary.High / total) * 100).toFixed(0)
      },
      Medium: {
        count: summary.Medium,
        percent: ((summary.Medium / total) * 100).toFixed(0)
      },
      Low: {
        count: summary.Low,
        percent: ((summary.Low / total) * 100).toFixed(0)
      },
      Normal: {
        count: summary.Normal,
        percent: ((summary.Normal / total) * 100).toFixed(0)
      }
    };
  }
  },
  watch: {
    data: {
      handler(newVal) {
        console.log('Data changed:', newVal);
        console.log('Data length:', newVal.length);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    renderDummyDoughnutChart() {
      if (!this.$refs.dummyDoughnutChart) return;

      const ctx = this.$refs.dummyDoughnutChart.getContext("2d");

      if (this.dummyChart) {
        this.dummyChart.destroy();
      }

      const centerTextPlugin = {
        id: "centerText",
        beforeDraw(chart) {
          const { width, height, ctx } = chart;

          ctx.save();
          ctx.font = "bold 14px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText("Site Priority", width / 2, height / 2);
          ctx.restore();
        }
      };

     this.dummyChart = new Chart(ctx, {
  type: "doughnut",
  data: {
    datasets: [{
      data: [
        this.prioritySummary.High.count,
        this.prioritySummary.Medium.count,
        this.prioritySummary.Low.count,
        this.prioritySummary.Normal.count
      ],
      backgroundColor: ["#ff6b6b", "#ffc857", "#4dabf7", "#20c997"]
    }]
  },

  options: {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",

    legend: {
      display: false
    },

    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {

          const names = ["High", "Medium", "Low", "Normal"];
          const label = names[tooltipItem.index];
          const value = data.datasets[0].data[tooltipItem.index] || 0;
          return label + ": " + value;
        }
      }
    }
  }
});

    },
    renderScoreChart(sites, datasets) {
          if (!this.$refs.highRiskBarChart) return;

          const ctx = this.$refs.highRiskBarChart.getContext("2d");

          if (this.highRiskChart) {
            this.highRiskChart.destroy();
          }

          this.highRiskChart = new Chart(ctx, {
            type: "bar",
            data: {
              labels: sites,
              datasets
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              // plugins: {removed label
              legend: {
                display: true,
                onClick:null,
                labels: {
                  generateLabels: () => ([
                    { text: "High Risk", fillStyle: "#ff0000", strokeStyle: "#ff0000", lineWidth: 0 },
                    { text: "Medium Risk", fillStyle: "#ff9100", strokeStyle: "#ff9100", lineWidth: 0 },
                    { text: "Low Risk", fillStyle: "#22ff05", strokeStyle: "#3fff05", lineWidth: 0 }
                  ])
                }
              },
              tooltips: {
                callbacks: {
                  label: (ttItem, data) => {
                    const ds = data.datasets[ttItem.datasetIndex];
                    return `${ds.label}: ${ttItem.yLabel}`;
                  }
                }
              },
              // },
              scales: {
                xAxes: [{
                  stacked: false,
                  categoryPercentage: 0.7,
                  barPercentage: 0.9,
                  scaleLabel: {
                    display: true,
                    labelString: "Sites"
                  }
                }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    min: 0,
                    max: 27,
                    beginAtZero: true,
                    stepSize: 5
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Risk Score"
                  }
                }]
              },

            }

          });
    },
    async getCraScheduleList() {
  try {
    const studyId = store.getters.getStudyIs;

    const url = `${this.baseurl}/forms/cra/craschedulelist`;

    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${store.getters.getIdToken}`,
        "Content-Type": "application/json"
      },
      params: {
        studyId: studyId
      }
    });

    this.craScheduleList = res.data.results || [];

    /* IMPORTANT PART */
    this.craScheduleMap = Object.fromEntries(
      this.craScheduleList.map(x => [x.siteId, x.craScheduleId])
    );

    console.log("CRA Schedule Map:", this.craScheduleMap);

  } catch (error) {
    console.error("CRA Schedule List Error:", error);
  }
    },
    async craScoreBasedGraph() {
      const studyId = store.getters.getStudyIs;
      try {
        

        const res =await axios.get(`${this.baseurl}/forms/cra/crascorebasedgraph?studyId=${studyId}`, 

         {
          headers: {
            Authorization: `Bearer ${store.getters.getIdToken}`,
            "Content-Type": "application/json"
          },
          
        });

        console.log("crascorebasedgraph Response:", res.data);
        return(res.data);

      } catch (error) {
        console.error("crascorebasedgraph API Error:", error.response || error);
      }
    },
    async getTrendAnalyze() {
      try {
        const studyId = store.getters.getStudyIs;

        const url = `${this.baseurl}/forms/cra/gettrendanalyze`;

        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${store.getters.getIdToken}`,
            "Content-Type": "application/json"
          },
          params: {
            studyId: studyId,
            includeDetails: false
          }
        });

        console.log("Trend Analyze Response:", res.data);
        return(res.data);

      } catch (error) {
        console.error("Trend Analyze API Error:", error.response || error);
      }
    },
    async getWeightedriskindex() {
      try {
        const studyId = store.getters.getStudyIs;

        const url = `${this.baseurl}/forms/cra/getweightedriskindex`;

        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${store.getters.getIdToken}`,
            "Content-Type": "application/json"
          },
          params: {
            studyId: studyId,
            includeDetails: false
          }
        });

        console.log("Weighted Risk Index Response:", res.data);
         return(res.data);

      } catch (error) {
        console.error("Weighted Risk Index API Error:", error.response || error);
      }
    },
  // Filter to ONLY High Risk sites
  async combineSiteApis() {
  this.currentPageSite = 1;

  const [scoreRes, trendRes, wriRes] = await Promise.all([
    this.craScoreBasedGraph(),
    this.getTrendAnalyze(),
    this.getWeightedriskindex()
  ]);

  const scoreSites = scoreRes?.sites || [];
  const trendSites = trendRes?.sites || [];
  const wriSites = wriRes?.sites || wriRes?.entities || [];

  const trendMap = Object.fromEntries(trendSites.map(site => [site.siteCode, site]));
  const wriMap = Object.fromEntries(wriSites.map(site => [site.siteCode, site]));

  // Combine all site data
  let combinedSites = scoreSites.map(site => {
    const trendData = trendMap[site.siteCode] || {};
    const wriData = wriMap[site.siteCode] || {};

    const trend = (trendData.trends || []).map(item => ({ name: item.name, value: item.value }));
    const zscore = (wriData.zscores || []).map(item => ({ name: item.name, value: item.value }));
    const weightage = (wriData.weightage || []).map(item => ({ name: item.name, value: item.value }));

    const kpiNames = (site.kpis || []).map(k => k.riskName).join(', ');

    return {
      ...site,
      wri: wriData.wri || "-",
      riskLevel: wriData.riskLevel,
      visitRequired: wriData.visitRequired,
      trend: trendData.trendSlope,
      trendStatus: trendData.trendStatus || "-",
      trendDirection: trendData.trendDirection || "-",
      hasspike:trendData.hasSpike || "-",
      PeakRiskScore:trendData.peakRiskScore || "-",
      datapoints: trendData.dataPoints || [],
      trendPercent: trendData.trendPercent,
      pidMax: site.pidMax || "-",
      breach: site.breach || "-",
      visitPriority: site.visitPriority || site.priority || "-",
      action: site.action || "View",
      lastUpdate: site.generatedAt || "-",
      kpiNames,
      trendArray: trend,
      zscoreArray: zscore,
      weightageArray: weightage
    };
  });

  // Filter to ONLY High Risk sites
  this.siteList = combinedSites.filter(site => site.riskLevel?.toLowerCase() === "high");

  // Save copy for All Sites button
  this.Allsites = [...combinedSites];

  console.log("High Risk Sites Only 👉", this.siteList);
    },
    closeCycleModal() {
      this.showCreateCycleModal = false;
      this.selectedSiteCode = null;
    },
     CreateCycle(siteCode) {
      this.selectedSiteCode = siteCode || null;
      this.showCreateCycleModal = true;
    },
    showAllSites() {
    this.currentPageSite = 1;

    // Sort all sites High → Medium → Low
    const RISK_PRIORITY = { High: 1, Medium: 2, Low: 3 };
    this.siteList = [...this.Allsites].sort((a, b) => {
      const diff = (RISK_PRIORITY[a.riskLevel] || 4) - (RISK_PRIORITY[b.riskLevel] || 4);
      if (diff !== 0) return diff;
      return a.siteCode.localeCompare(b.siteCode); // fallback alphabetical
    });

    console.log("All Sites Sorted by Risk 👉", this.siteList);
    },
    HighRiskSites() {
      this.currentPageSite = 1;
      this.siteList = this.siteList.filter(site => site.riskLevel === "High");
    },
    loadPageSite(page) {
      this.currentPageSite = page;
    },
   async getWeightedriskindexscore(latestVisitCount = 2) {
  try {

    const url = `${this.baseurl}/forms/cra/getweightedriskindex`;

    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${store.getters.getIdToken}`,
        "Content-Type": "application/json"
      },
      params: {
        studyId: this.studyId,
        includeBreakdown: true,
        includeRanking: true,
        latestVisitCount: latestVisitCount
      }
    });

    /* ---------- CALL TREND API HERE ---------- */
    const trendRes = await this.getTrendAnalyze();
    const trendSites = trendRes?.sites || [];

    const trendMap = Object.fromEntries(
      trendSites.map(site => [site.siteCode, site])
    );
    /* ---------------------------------------- */
/* ---------- CALL CRA SCORE API ---------- */
    const scoreRes = await this.craScoreBasedGraph();
    const scoreSites = scoreRes?.sites || [];

    const scoreMap = Object.fromEntries(
      scoreSites.map(site => [site.siteCode, site])
    );
/* --------------------------------------- */

    this.kpiList = (res.data.sites || res.data.entities || []).map(site => {

      const trendData = trendMap[site.siteCode] || {};
      const scoreData = scoreMap[site.siteCode] || {};

      return {
        siteCode: site.siteCode,
        wri: site.wri || "-",

        /* TREND VALUES */
        trendSlope: trendData.trendSlope || "-",
        trendStrength: trendData.trendStrength || "-",
        volatility:trendData.volatility|| "-",
        hasspike:trendData.hasSpike,
        trendDirection: trendData.trendDirection || "-",
        trendStatus: trendData.trendStatus || "-",
        averageRiskScore:trendData.averageRiskScore || "-",
        PeakRiskScore:trendData.peakRiskScore || "-",
        datapoints: trendData.dataPoints || "-",
        attentionLevel: trendData.attentionLevel || "-",
        requireattention: trendData.requireAttention || false,
        recommendation: trendData.recommendedAction || "-",
        trendPercent: trendData.trendPercent || "-",
        craVisitID:site.nextVisit?.id || "-",
        visitName: site.nextVisit?.visitName || "-",
        craVisitType: site.nextVisit?.craVisitType || "-",
        plannedDate: site.nextVisit?.plannedDate || "-",
        status: site.nextVisit?.status || "-",
        monitoringMode: site.nextVisit?.monitoringMode || "-",
        
    /* CRA SCORE VALUES (NEW) */
        pidMax: scoreData.pidMax || "-",
        breach: scoreData.breach || "-",
        generatedAt: scoreData.generatedAt || "-",
        maxzscore: scoreData.maxZScore || "-",
        weightedZScore: scoreData.weightedZScore || "-",
        visittyperequiered: scoreData.visitRequired,
        // visitName: site.nextVisit?.visitName || "-",
        // craVisitType: site.nextVisit?.craVisitType || "-",
        // plannedDate: site.nextVisit?.plannedDate || "-",
        // status: site.nextVisit?.status || "-",
        // monitoringMode: site.nextVisit?.monitoringMode || "-",
        riskLevel: site.riskLevel || "-",

        

        kpis: (site.kpis || []).map(k => ({
          name: k.riskName,
          score: k.score || 0,
          value: k.value || 0,
          zScore: k.zScore || 0,
          weight: k.weight || 0,
          mean: k.mean || 0,
          level: k.riskLevelLabel || "Low",
          percent: k.percent || 0
        }))
      };
    });

    return this.kpiList;

  } catch (error) {
    console.error("Weighted Risk Index API Error:", error.response || error);
    return null;
  }
    },
    formatDate(date){
       return date ? moment(date).format(this.defaultdate) : "-";
    },
    async getTrendNewAnalyze() {
      try {
        const studyId = store.getters.getStudyIs;

        const url = `${this.baseurl}/forms/cra/gettrendanalyze`;

        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${store.getters.getIdToken}`,
            "Content-Type": "application/json"
          },
          params: {
            studyId: studyId,
            includeDetails: false
          }
        });

        console.log("Trend Analyze Response:", res.data);
        this.trendNewAnalyze=res.data?.sites||[];
        return(res.data);

      } catch (error) {
        console.error("Trend Analyze API Error:", error.response || error);
      }
    },
   opencreateschdule(siteId, siteCode) {

  const craId = this.craScheduleMap[siteId];

   if (craId) {
    /* EDIT EXISTING SCHEDULE */
    this.craScheduleId = craId;
    this.showCraModel = true;
    }
    else {
    /* CREATE NEW SCHEDULE */
    this.siteId = siteId;
    this.siteCodeforpopup = siteCode;
    this.createschedulemodel = true;
  }
    },

    closeModal() {
      this.$emit("closeModal");
    },
     CreateCra() {
      this.editingCraId = null;
      this.showCreateCraModal = true;
    },
    EditCRA(Id) {
          this.editingCraId = Id;
          console.log("Editing CRA with ID:", Id);
          this.showCreateCraModal = true;
    },
    // EditCRA(Id, studyId) {
    //   this.editingCraId = Id;
    //   console.log("Editing CRA with ID:", Id);
    //   this.showCreateCraModal = true;
    // },
    closeCranewModal() {
      this.showCreateCraModal = false;
      this.editingCraId = null;
    },
     getProgressStyle(score) {
     let color = "";

    if (score >= 20 && score <= 40) {
       color = "#dc3545"; 
    } 
    else if (score >= 60) {
      color = "#ffc107";
    } 
    else if (score >= 40) {
      color = "#051330"; 
    } 
    else {
      color = "#28a745";
    }
    return {
      width: score + "%",
      backgroundColor: color
    };
    },
    toggleKpiPerSite(siteCode) {
    if (this.expandedKpiSites.has(siteCode)) {
      this.expandedKpiSites.delete(siteCode);
    } else {
      this.expandedKpiSites.add(siteCode);
    }
    },
  
    isKpiExpanded(siteCode) {
      return this.expandedKpiSites.has(siteCode);
    },
    toggleKpi() {
      this.showKpiPerformance = !this.showKpiPerformance;
    },
  // ...existing methods
    attentionColor(level) {
      switch (level) {
        case "High":
          return "red";
        case "Medium":
          return "yellow";
        case "Low":
          return "green";
        case "Normal":
          return "blue";
        default:
          return "black"; // fallback color
      }
    },
    cancelModeChange() {
      console.log("Mode change cancelled");
      // Add any logic you want when user clicks No
      // For example, close a dropdown or reset UI state
    },


  },
};